import TextField from "@mui/material/TextField";
import { useTranslation } from "react-i18next";
import {
  CUSTOMER_PHONE_MAX_LENGTH,
  formatCustomerPhone,
  isCustomerPhoneFormatValid,
} from "../../../../lib/customer/phone";

type CustomerPhoneFieldProps = {
  id: string;
  name: "phone" | "mobilePhone";
  label: string;
  value: string;
  onChange: (value: string) => void;
};

const CustomerPhoneField = ({ id, name, label, value, onChange }: CustomerPhoneFieldProps) => {
  const { t } = useTranslation();
  const formatted = formatCustomerPhone(value);
  const invalid = !isCustomerPhoneFormatValid(formatted);

  return (
    <TextField
      fullWidth
      id={id}
      name={name}
      label={label}
      variant="outlined"
      size="small"
      type="tel"
      value={formatted}
      onChange={(event) => onChange(formatCustomerPhone(event.target.value))}
      error={invalid}
      helperText={invalid ? t("customers.phoneInvalid") : t("customers.phoneHelper")}
      inputProps={{
        inputMode: "numeric",
        autoComplete: "tel",
        maxLength: CUSTOMER_PHONE_MAX_LENGTH,
      }}
    />
  );
};

export default CustomerPhoneField;
